export default [
  {
    name: 'getSysRole',
    method: 'GET',
    path: '/vue/role/role-get'
  },
  {
    name: 'getSysRoleList',
    method: 'POST',
    path: '/vue/role/role-page'
  },
  {
    name: 'saveSysRole',
    method: 'POST',
    path: '/vue/role/role-save'
  },
  {
    name: 'savePermissions',
    method: 'POST',
    path: '/vue/role/role-savePermissions'
  },
  {
    name: 'deleteSysRole',
    method: 'POST',
    path: '/vue/role/role-delete'
  },
  {
    name: 'deleteAccountRole',
    method: 'GET',
    path: '/vue/role/role-delete-account-role'
  },
  {
    name: 'getAllList',
    method: 'GET',
    path: '/vue/role/role-getAllList'
  },
  {
    name: 'getByUserId',
    method: 'GET',
    path: '/vue/role/role-get-by-user-id'
  },
  {
    name: 'roleCodeCheck',
    method: 'POST',
    path: '/vue/role/roleCodeCheck'
  }
];
